const phoneIsIncomplete = context => {
  const { purePhone, error, loading } = context;
  return loading || Boolean(error) || purePhone.length < 10;
};

export default phoneIsIncomplete;
